import React from 'react';
import { JobRecruitFreeSpaceResponse } from '@doda/api-client/aspida/@types';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { SectionItem } from '../../SectionItem';
import styles from './index.module.scss';

/**
 * FreeTextAreaのProps
 */
interface FreeTextAreaProps {
  freeSpaces: JobRecruitFreeSpaceResponse[];
}

/**
 * 求人詳細 フリー見出し
 *
 * @param props.freeSpaces - 仕事内容概要の区分
 */
export const FreeTextArea: React.FC<FreeTextAreaProps> = ({ freeSpaces }) => {
  return (
    <>
      {freeSpaces
        ?.filter((item) => item.text)
        .map((freeSpace) => {
          return (
            <div
              key={freeSpace.index}
              className={styles['jobSearchDetail-freeTextArea']}
            >
              <SectionItem label={freeSpace.heading}>
                <TextWithLF text={freeSpace.text || ''} />
              </SectionItem>
            </div>
          );
        })}
    </>
  );
};
